export const ONBOARDING_BILLING_FLOW_STEPS_WITH_CREDIT_CARD = {
  BILLING: 1,
  PAYMENT: 2,
  CONFIRMATION: 3,
};

export const ONBOARDING_BILLING_FLOW_STEPS_WITH_MANUAL_PAYMENT = {
  BILLING: 1,
  CONFIRMATION: 2,
};

export const BASE_URL = window.__CONFIG__ ? window.__CONFIG__.BASE_URL : '/';
